import { useAuth0 } from '@auth0/auth0-react';
import type { Private } from '@seek/indie-api-types';
import { useQuery } from '@tanstack/react-query';
import React, { type ReactNode, useContext } from 'react';

import { useApi } from '#src/api/index.ts';

const ctx = React.createContext<Private.GrantsPayload | null>(null);

export const GrantsProvider = ({ children }: { children: ReactNode }) => {
  const api = useApi();
  const { isAuthenticated } = useAuth0();
  const { data: grants = null } = useQuery({
    queryKey: ['grants', isAuthenticated, api],
    queryFn: ({ signal }) => (isAuthenticated ? api.grants.list(signal) : null),
  });

  return <ctx.Provider value={grants}>{children}</ctx.Provider>;
};

export const useGrants = () => useContext(ctx);
